module.exports = {
  EXPERIMENT_SUMMARIES_FETCHED: 'EXPERIMENT_SUMMARIES_FETCHED',
  CLIENT_INITIALISED: 'CLIENT_INITIALISED',
  VARIANT_CALCULATED: 'VARIANT_CALCULATED',
  EXPERIMENT_NOT_FOUND: 'EXPERIMENT_NOT_FOUND',
  EXPERIMENT_TRACKED: 'EXPERIMENT_TRACKED',
  GOAL_NOT_FOUND: 'GOAL_NOT_FOUND',
  GOAL_TRACKED: 'GOAL_TRACKED',
  EXPERIMENT_SUMMARIES_ERROR: 'EXPERIMENT_SUMMARIES_ERROR',
  EXPERIMENT_NOT_RUNNING: 'EXPERIMENT_NOT_RUNNING'
};



// WEBPACK FOOTER //
// ./src/ab-types.js